module.exports = __WEBPACK_EXTERNAL_MODULE__LENOX__d7e272fb__;